/**
 * Formátování hodnot pro uživatele. Veškeré formátování v aplikaci jde přes
 * tento modul - nikde jinde se nevolá toLocaleString přímo.
 */
const LOCALE = 'cs-CZ'
const TIME_ZONE = 'Europe/Prague'

const dateFormatter = new Intl.DateTimeFormat(LOCALE, { dateStyle: 'medium', timeZone: TIME_ZONE })
const dateTimeFormatter = new Intl.DateTimeFormat(LOCALE, { dateStyle: 'medium', timeStyle: 'short', timeZone: TIME_ZONE })
const weekdayFormatter = new Intl.DateTimeFormat(LOCALE, { weekday: 'short', day: 'numeric', month: 'numeric', timeZone: TIME_ZONE })

function toDate(value: string | Date): Date {
    return value instanceof Date ? value : new Date(value)
}

export function formatDate(value: string | Date): string {
    return dateFormatter.format(toDate(value))
}

export function formatDateTime(value: string | Date): string {
    return dateTimeFormatter.format(toDate(value))
}

export function formatDayWithWeekday(value: string | Date): string {
    return weekdayFormatter.format(toDate(value))
}

/** Datum ve tvaru YYYY-MM-DD pro vstupní pole typu date. */
export function toDateInputValue(value: string | Date): string {
    return new Intl.DateTimeFormat('en-CA', { timeZone: TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit' }).format(toDate(value))
}
